import React from 'react';
import styled from 'styled-components';
import CareerClusterCheckbox from 'apps/career-clusters/components/career-clusters-survey/survey-sections/career-clusters-checkbox';
import { resolve } from 'library/helpers/path-resolver';
import { object, func, array, ref } from 'prop-types';

const StyledCareerClusterSurveyQuestions = styled.div`
  .questions {
    display: flex;
    justify-content: space-around;
    max-width: 843px;
    flex-wrap: wrap;
  }
  p:focus {
    outline: none;
  }
`;

const CareerClustersSurveyQuestions = ({ career_cluster_survey_category, handleCheck, answered_questions, descriptionRef }) => (
  <StyledCareerClusterSurveyQuestions>
    <p tabIndex="-1" ref={descriptionRef}> {resolve(career_cluster_survey_category, 'description', 'Select all that apply.')} </p>
    <p style={{ fontWeight: 400 }}>  Scroll to view all of the options. </p>
    <div className="questions">
      {resolve(career_cluster_survey_category, 'questions', [])
        .map(question =>
          <CareerClusterCheckbox
            key={question.id}
            id={question.id}
            question={question.question}
            toggleActive={handleCheck}
            active={answered_questions.includes(question.id)}/>
        )}
    </div>
  </StyledCareerClusterSurveyQuestions>
);

CareerClustersSurveyQuestions.propTypes = {
  career_cluster_survey_category: object,
  handleCheck: func,
  answered_questions: array,
  descriptionRef: ref
};

export default CareerClustersSurveyQuestions;
